<script setup lang="ts">
import { ref } from 'vue'

const STORAGE_KEY = 'age_gate_confirmed_at'
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000

const storedAt = Number(localStorage.getItem(STORAGE_KEY) ?? 0)
const isAllowed = ref(storedAt > 0 && Date.now() - storedAt < THIRTY_DAYS_MS)
const declined = ref(false)

function allow(): void {
  localStorage.setItem(STORAGE_KEY, String(Date.now()))
  isAllowed.value = true
}
</script>

<template>
  <slot v-if="isAllowed" />
  <div v-else class="fixed inset-0 z-[100] grid place-items-center bg-[#080406] p-6">
    <div class="w-full max-w-lg rounded-[2rem] border border-white/10 bg-[#16070d] p-8 text-center shadow-2xl">
      <div class="mx-auto mb-6 grid size-16 place-items-center rounded-full bg-[#7a1632]/25 text-3xl">✦</div>
      <h1 class="font-display text-3xl text-white">Conteúdo para maiores de 18 anos</h1>
      <p class="mt-4 text-sm leading-6 text-white/65">
        Confirme que você possui 18 anos ou mais para continuar.
      </p>
      <template v-if="!declined">
        <button class="primary-button mt-8 w-full" type="button" @click="allow">Tenho 18 anos ou mais</button>
        <button class="secondary-button mt-3 w-full" type="button" @click="declined = true">Sair do site</button>
      </template>
      <p v-else class="mt-8 rounded-2xl bg-black/20 p-5 text-sm text-white/65">
        O conteúdo principal não será exibido neste acesso.
      </p>
    </div>
  </div>
</template>
